/**
 * Datos de países y ciudades para dropdowns dependientes.
 * Estructura: { código_país: { name, cities: [...] } }
 */
const countryCityData = {
  PE: {
    name: 'Perú',
    cities: [
      'Lima', 'Arequipa', 'Trujillo', 'Chiclayo', 'Piura',
      'Iquitos', 'Cusco', 'Huancayo', 'Tacna', 'Ica',
      'Pucallpa', 'Chimbote', 'Sullana', 'Ayacucho', 'Juliaca',
      'Huánuco', 'Cajamarca', 'Puno', 'Tumbes', 'Tarapoto',
      'Moyobamba', 'Huaraz', 'Cerro de Pasco', 'Puerto Maldonado',
      'Moquegua', 'Abancay', 'Chachapoyas', 'Huancavelica',
    ],
  },
  ES: {
    name: 'España',
    cities: [
      'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza',
      'Málaga', 'Murcia', 'Palma de Mallorca', 'Las Palmas', 'Bilbao',
      'Alicante', 'Córdoba', 'Valladolid', 'Vigo', 'Gijón',
      'Granada', 'A Coruña', 'Vitoria-Gasteiz', 'Santa Cruz de Tenerife',
      'Pamplona', 'Santander', 'Toledo', 'Badajoz', 'Logroño',
    ],
  },
  CO: {
    name: 'Colombia',
    cities: [
      'Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena',
      'Cúcuta', 'Bucaramanga', 'Pereira', 'Santa Marta', 'Ibagué',
      'Pasto', 'Manizales', 'Neiva', 'Villavicencio', 'Armenia',
      'Valledupar', 'Montería', 'Sincelejo', 'Popayán', 'Tunja',
    ],
  },
  MX: {
    name: 'México',
    cities: [
      'Ciudad de México', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana',
      'León', 'Juárez', 'Zapopan', 'Mérida', 'Cancún',
      'Querétaro', 'San Luis Potosí', 'Aguascalientes', 'Hermosillo',
      'Chihuahua', 'Morelia', 'Saltillo', 'Veracruz', 'Toluca', 'Oaxaca',
    ],
  },
  AR: {
    name: 'Argentina',
    cities: [
      'Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán',
      'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan',
      'Resistencia', 'Neuquén', 'Corrientes', 'Posadas', 'Bahía Blanca',
      'Paraná', 'San Salvador de Jujuy', 'Río Gallegos', 'Ushuaia',
    ],
  },
  CL: {
    name: 'Chile',
    cities: [
      'Santiago', 'Valparaíso', 'Concepción', 'Antofagasta', 'Viña del Mar',
      'Temuco', 'Rancagua', 'Talca', 'Arica', 'Iquique',
      'Puerto Montt', 'Coquimbo', 'La Serena', 'Osorno', 'Valdivia',
      'Punta Arenas', 'Copiapó', 'Chillán',
    ],
  },
  EC: {
    name: 'Ecuador',
    cities: [
      'Quito', 'Guayaquil', 'Cuenca', 'Santo Domingo', 'Machala',
      'Durán', 'Manta', 'Portoviejo', 'Loja', 'Ambato',
      'Riobamba', 'Esmeraldas', 'Ibarra', 'Latacunga', 'Tulcán',
    ],
  },
  BO: {
    name: 'Bolivia',
    cities: [
      'La Paz', 'Santa Cruz', 'Cochabamba', 'Sucre', 'Oruro',
      'Tarija', 'Potosí', 'Trinidad', 'Cobija',
    ],
  },
  VE: {
    name: 'Venezuela',
    cities: [
      'Caracas', 'Maracaibo', 'Valencia', 'Barquisimeto', 'Maracay',
      'Ciudad Guayana', 'Barcelona', 'Maturín', 'San Cristóbal', 'Mérida',
    ],
  },
  UY: {
    name: 'Uruguay',
    cities: [
      'Montevideo', 'Salto', 'Paysandú', 'Las Piedras', 'Rivera',
      'Maldonado', 'Tacuarembó', 'Melo', 'Mercedes', 'Artigas',
    ],
  },
  PY: {
    name: 'Paraguay',
    cities: [
      'Asunción', 'Ciudad del Este', 'San Lorenzo', 'Luque', 'Capiatá',
      'Lambaré', 'Fernando de la Mora', 'Encarnación', 'Pedro Juan Caballero',
    ],
  },
};

/**
 * Obtiene la lista de países como opciones para un select.
 * @returns {Array<{value: string, label: string}>}
 */
export const getCountryOptions = () => {
  return Object.entries(countryCityData).map(([code, data]) => ({
    code,
    value: data.name,
    label: data.name,
  }));
};

/**
 * Obtiene las ciudades de un país dado su nombre.
 * @param {string} countryName - Nombre del país (ej: "Perú")
 * @returns {Array<string>} Lista de ciudades ordenadas alfabéticamente
 */
export const getCitiesByCountry = (countryName) => {
  if (!countryName) return [];
  const entry = Object.values(countryCityData).find(
    (data) => data.name.toLowerCase() === countryName.toLowerCase()
  );
  return entry ? [...entry.cities].sort() : [];
};

/**
 * Obtiene todas las ciudades de todos los países (para búsqueda global).
 * @returns {Array<string>}
 */
export const getAllCities = () => {
  const allCities = new Set();
  Object.values(countryCityData).forEach((data) => {
    data.cities.forEach((city) => allCities.add(city));
  });
  return [...allCities].sort();
};

export default countryCityData;
